import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { QBOEnvironment } from 'src/environments/environment';
import { CommonPagesService } from '../../common-pages.service';
import { ResponseStatus } from '../../enum';

@Component({
  selector: 'app-add-update-expense',
  templateUrl: './add-update-expense.component.html',
  styleUrls: ['./add-update-expense.component.scss'],

  standalone: false,
})
export class AddUpdateExpenseComponent implements OnInit {
  isVisibleExpenseModal: any = true;
  isLoadingPrograms: any = false;
  isLoadingExpense: any = false;
  isLoadingTags: any = false;
  isExpenseSkeleton: any = false;
  listOfProgramPeriods: any;
  qboOriginalbillLink: any = null;
  getExpenseDetail: any;
  selectedTag: any;
  @Output() hideExpenseDrawer = new EventEmitter();
  @Input() selectedData: any;
  selectedTagGroup: any = '';
  listOfTags: any[] = [];
  listOfUnfilteredTags: any[] = [];
  qboURL = QBOEnvironment.URL;
  isResyncingData: boolean = false;
  isMarkingReviewed: boolean;
  currentReviewReason: any = {};
  isConfirmUnderReviewVisible: boolean;
  listOfUnderReviewReasons: any;
  reviewReason: any;

  constructor(
    public _cS: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService,
    private sanitizer: DomSanitizer
  ) {
    _fS.expenseForm_fb();
  }
  ngOnInit(): void {
    this.getExpenseDetails();
    // this.loadPrograms('');
  }

  handleCancel(data: any) {
    this.isVisibleExpenseModal = false;
    this.hideExpenseDrawer.emit({
      hide: this.isVisibleExpenseModal,
      data: data,
    });
  }
  resynExpenseData() {
    this.isResyncingData = true;
    this._cpS
      .resyncExpenseData(this.selectedData.id)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          if (response.result.isExpenseDeleted) {
            this._cS.displayMessage(
              'warning',
              'This transaction is deleted from QBO'
            );
            this.isResyncingData = false;
            this.handleCancel(response.result);
          } else {
            this.isResyncingData = false;
            this.getExpenseDetail = response.result;
            this._cS.displayMessage('success', response.message);
          }
        } else {
          this.isResyncingData = false;
          this._cS.displayMessage('error', response.message);
        }
      });
  }
  getUnderReviewReasons() {
    this._cpS.getAllPaymentUnderReview().subscribe((response: any) => {
      if (response.responseStatus == ResponseStatus.success) {
        this.listOfUnderReviewReasons = response.result;

        // if (!this.getExpenseDetail?.isMarkedAsUnderReview) {
        // this.reviewReason = this.listOfUnderReviewReasons[0]?.id;
        // this.underReviewReasonChange();
        // }
      }
    });
  }
  underReviewReasonChange() {
    this.currentReviewReason = this.listOfUnderReviewReasons.find(
      (x: any) => x.id == this.reviewReason
    );
  }
  markExpenseUnderReview() {
    this.isConfirmUnderReviewVisible = true;
  }
  updateTransactionWithUnderRviewReason(isUnderReview: boolean) {
    if (isUnderReview && !this.reviewReason) {
      this._cS.displayMessage(
        'warning',
        'Please select a reason to mark as under review'
      );
    } else {
      this.isMarkingReviewed = true;
      if (!isUnderReview) {
        // this.reviewReason = this.getExpenseDetail.underReviewId;
        // this.currentReviewReason = this.listOfUnderReviewReasons.find(
        //   (x: any) => x.id == this.getExpenseDetail.underReviewId
        // );
        // console.log('currentReviewReason', this.currentReviewReason);

        this.currentReviewReason['id'] = this.getExpenseDetail.underReviewId;
        this.currentReviewReason['reason'] =
          this.getExpenseDetail.underReviewReason;
        this.currentReviewReason['color'] =
          this.getExpenseDetail.underReviewColor;
        this.currentReviewReason['emailCopy'] = this.getExpenseDetail.emailCopy;
      }
      var requestBody = {
        id: this.selectedData.id,
        transactionType: 3,
        underReviewId: this.currentReviewReason.id,
        reason: this.currentReviewReason.reason,
        color: this.currentReviewReason.color,
        isMarkedAsUnderReview: isUnderReview,
        emailCopy: this.currentReviewReason.emailCopy,
      };
      this._cpS
        .updateTransactionUnderReview(requestBody)
        .subscribe((response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            this._cS.displayMessage('success', response.message);
            this.isMarkingReviewed = false;
            this.isConfirmUnderReviewVisible = false;
            this.getExpenseDetail['underReviewId'] =
              this.currentReviewReason.id;
            this.getExpenseDetail['underReviewReason'] =
              this.currentReviewReason.reason;
            this.getExpenseDetail['underReviewColor'] =
              this.currentReviewReason.color;
            this.getExpenseDetail['isMarkedAsUnderReview'] = isUnderReview;
            this.reviewReason = '';
            // this.isVisibleBillModal = false;
            // this.hideExpenseDrawer.emit({
            //   hide: this.isVisibleBillModal,
            //   data: response.result,
            // });
            this._cS.underReviewCount.next('call');
          } else {
            this._cS.displayMessage('error', response.message);
            this.isMarkingReviewed = false;
          }
        });
    }
  }

  getExpenseDetails() {
    this.isExpenseSkeleton = true;
    this._cpS
      .GetExpenseDetail(this.selectedData.id)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.getExpenseDetail = response.result;

          this._fS.expenseForm.patchValue({
            programPeriod: this.getExpenseDetail?.program?.id,
            tags: this.getExpenseDetail?.tag?.id,
            isNonAlc: this.getExpenseDetail?.isNonAlc,
          });
          if (this.getExpenseDetail?.isMarkedAsUnderReview) {
            // this.currentReviewReason = this.getExpenseDetail?.underReviewId;
            // this.reviewReason = this.getExpenseDetail?.underReviewId;
          }
          this.getUnderReviewReasons();
          this.getTags();
          this.loadPrograms();
          this.getSiteDetails();
          this.previewQBOAttachment(this.getExpenseDetail?.qboAttachmentId);
          this.isExpenseSkeleton = false;
        }
      });
  }
  siteDetails: any;
  getSiteDetails() {
    this._cpS
      .GetSiteDetails(this.getExpenseDetail.siteId)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.siteDetails = response.result;
        }
      });
  }
  loadPrograms() {
    this.isLoadingPrograms = true;
    this._cpS.getProgramBySite(this.getExpenseDetail.siteId).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isLoadingPrograms = false;
          this.listOfProgramPeriods = response.result;
          var defaultProgram = this.listOfProgramPeriods.find(
            (x: any) => x?.isDefault
          );
          if (this.selectedData == null) {
            this._fS.expenseForm.patchValue({
              programPeriod: defaultProgram?.id,
            });
          }
        } else {
          this.listOfProgramPeriods = [];
          this.isLoadingPrograms = false;
          this._cS.displayMessage('error', response.message);
        }
      },
      (error: any) => {
        this.listOfProgramPeriods = [];
        this.isLoadingPrograms = false;
      }
    );
  }

  getTags() {
    this.isLoadingTags = true;
    this._cpS.getTagsDropdownList(this.getExpenseDetail.siteId).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.listOfTags = response.result;
          // response.result.forEach((tagGroup: any) => {
          //   tagGroup.Tags.forEach((tag: any) => {
          //     this.listOfTags.push({
          //       tagGroupName: tagGroup.Name,
          //       id: tag._id,
          //       tagName: tag.Name,
          //     });
          //   });
          // });
          this.checkTagGroupData(this.getExpenseDetail?.tag?.id);
          this.isLoadingTags = false;
        } else {
          this.isLoadingTags = false;
          this._cS.displayMessage('error', response.message);
          this.listOfTags = [];
        }
      },
      (error: any) => {
        this.isLoadingTags = false;
        this.listOfTags = [];
      }
    );
  }
  searchTagGroupAndTags(searchTerm) {
    // Make the search term case insensitive
    const lowerCaseSearchTerm = searchTerm.toLowerCase();

    const result = this.listOfTags
      .map((item) => {
        // Check if the event's Name matches the search term
        const isNameMatch =
          item.Name.toLowerCase().includes(lowerCaseSearchTerm);

        // Filter the tags that match the search term
        const matchingTags = item.Tags.filter((tag) =>
          tag.Name.toLowerCase().includes(lowerCaseSearchTerm)
        );

        // If the event name matches, include the whole item with all tags
        if (isNameMatch) {
          return {
            ...item,
            Tags: item.Tags,
          };
        }

        // If there are matching tags, include the item with only those tags
        if (matchingTags.length > 0) {
          return {
            ...item,
            Tags: matchingTags,
          };
        }

        // Otherwise, exclude this item
        return null;
      })
      .filter((item) => item !== null);

    // Output the result
    return result;
  }

  returnFilteredTags(searchTerm) {
    if (searchTerm) {
      const filteredResult = this.searchTagGroupAndTags(searchTerm);
      this.listOfTags = filteredResult;
    } else {
      this.listOfTags = this.listOfUnfilteredTags;
    }
  }

  checkTagGroupData(event: any) {
    var selectedGroup: any;
    var selectedTag: any;
    this.listOfTags.forEach((element: any) => {
      element.Tags.forEach((tag: any) => {
        if (tag._id == event) {
          selectedTag = tag;
          selectedGroup = element;
        }
      });
    });
    this.selectedTagGroup = selectedGroup;
    this.selectedTag = selectedTag?.Name;
  }

  updateExpense() {
    if (this._fS.expenseForm.valid) {
      this.isLoadingExpense = true;
      var formValueExpense = this._fS.expenseForm.value;

      var selectedProgram = this.listOfProgramPeriods.find(
        (x: any) => x.id == formValueExpense.programPeriod
      );
      var expenseData = {
        expenseId: this.selectedData.id,
        program: {
          id: formValueExpense.programPeriod,
          name: selectedProgram.label,
        },
        tag: {
          id: formValueExpense.tags,
          name: this.selectedTag,
          transcationids: [''],
        },
        isNonAlc: formValueExpense.isNonAlc,
      };
      this._cpS.updateExpense(expenseData).subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage('success', response.message);
          //hide unit drawer
          this.isVisibleExpenseModal = false;
          this.hideExpenseDrawer.emit({
            hide: this.isVisibleExpenseModal,
            data: null,
          });
          this.isLoadingExpense = false;
        } else {
          this._cS.displayMessage('error', response.message);
          this.isLoadingExpense = false;
        }
      });
    } else {
      //to fire validations on invalid fields
      Object.values(this._fS.expenseForm.controls).forEach((control: any) => {
        if (control.invalid) {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  previewQBOAttachment(qboAttachmentId: any) {
    if (qboAttachmentId != null && qboAttachmentId != 'null') {
      this._cpS
        .PreviewQBOAttachment(qboAttachmentId)
        .subscribe((response: any) => {
          if (response.responseStatus == ResponseStatus.success) {
            // this.qboOriginalbillLink = response.result.tempDownloadUri
            this.qboOriginalbillLink = this.getSafeUrl(
              response.result.tempDownloadUri
            );
          } else {
            this._cS.displayMessage('error', response.message);
          }
        });
    }
  }

  // to remove error : Error: unsafe value used in a resource URL context
  getSafeUrl(url: any) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
